import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EventFinder/EventFinderHomeTypes";
import { VAMtypes } from "../_loadingHelpers/VAM";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { EvBookingView, EvBookingEditor } from "../_loadingHelpers/VAMv2";
import { VAM2types } from "../_loadingHelpers/VAMv2Types";

class EventFinderLM extends compose(FinderBaseV2, _TabEnabledMixin) {
    //templateString = template;
    private editingEnabled: boolean = false;


    private bookingFormatter(cell: StaticTable.StaticTableCell<VAMtypes.EvBookingEditorEntity>): boolean {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "actions":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_show"],
                    "class": "mds-button-base round w3-center sL3 mds-hover-dark w3-large",
                    "onclick": lang.hitch(this, "tableRowButton_click", cell.tableRow),
                    "title": this.translations["Generic_show"],
                }, node);

                this.UiModder.domConstruct.create("I", { "class": "far fa-calendar-alt" }, btn);
                return true;
                break;
            default:
                return false;
        }
    }

    private tableRowButton_click(row: StaticTable.StaticTableRow<VAM2types.EvBooking_Base>,
        rowGroup: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>,
        evt) {

        this.openViewer(row.rowGroup.entity, evt);
    //    if (this.editingEnabled) {
    //        this.openEditor(row.rowGroup.entity, evt);
    //    } else {
    //        this.openViewer(row.rowGroup.entity, evt);
    //    }
    }

    private getOpenBookingById(entityId: string): any {
        let openIndex: number = -1;
        for (let index = 0; index < this.openedBookings.length; index++) {
            let openBooking = this.openedBookings[index];

            if (openBooking.entityID == entityId) {
                openIndex = index;
                return this.openedBookings[openIndex];
                break;
            }
        }

        return null;
    }
    private openedBookings: Array<{ entityID: string, form: any }>;
    openEditor(data: VAM2types.EvBooking_Base, evt?: MouseEvent) {
        if (evt) {
            evt.stopPropagation();
        }
        let label = this.translate("BookingEditor__CreateNewBooking");
        let heading = this.translate("General_Label_EvBookings");
        let GUID = (Math.random() * 100000).toString();

        let editor: MdsLax<InstanceType<typeof EvBookingEditor>> = null;

        if (data) {
            label = data.ev_booking_name;
            GUID = data.ID;
        } else {
            return;
        }

        let openBooking = this.getOpenBookingById(GUID);

        if (openBooking) {
            editor = openBooking.form;
        } else {
            editor = new EvBookingEditor();
        }




        let containerName = this.getTabContainerName();
        if (!openBooking && typeof containerName == "string") {
            this.createNewTabbedContent({
                enableClosing: true,
                label: label,
                groupLabel: heading,
                widget: editor,
                iconclass: "fas fa-edit",
                name: GUID,
                sidebarEntryName: GUID,
                targetContainerName: containerName
            }, true);

            editor.on("tabClosed", lang.hitch(this, this._onBookingClosed, GUID));
        }

        editor.on("saveDataResponse", lang.hitch(this, this.reload));
        editor.on("closed", lang.hitch(this, this._onBookingClosed, GUID));

        if (!openBooking) {
            this.openedBookings.push({
                entityID: GUID,
                form: editor
            });

            if (data) {
                editor.loadEntityById(data.ID);
            }

            editor.startup();

        } else {
            this.requestTabSwitchGlobal(GUID);
        }

    }
    openViewer(data: VAM2types.EvBooking_Base, evt?: MouseEvent) {

        if (evt) {
            evt.stopPropagation();
        }

        let bookingId = data.ID
        let form: MdsLax<InstanceType<typeof EvBookingView>> = null;
        let openBooking = this.getOpenBookingById(bookingId);

        if (!openBooking) {
            form = new EvBookingView();
            this.openedBookings.push({
                entityID: bookingId,
                form: form
            });
        } else {
            form = openBooking.form;
        }

        //let containerName = this.getTabContainerName();
        //if (!openBooking && typeof containerName == "string") {
        //    this.requestNewTabbedContentGlobal({
        //        enableClosing: true,
        //        label: data.ev_booking_name,
        //        widget: form,
        //        iconclass: "fas fa-calendar",
        //        name: data.ID,
        //        heading: this.translations["General_Label_EvBookings"],
        //        sidebarEntryName: data.ID,
        //        targetContainerName: containerName
        //    }, true);

        //    form.on("tabClosed", lang.hitch(this, this._onBookingClosed, data.ID));
        //}

        if (!openBooking) {
            form.setup(bookingId, data.ev_booking_name, null, "eventfinder_LM", this.getTabContainerName());
            form.startup();

            form.on("closed", lang.hitch(this, this._onBookingClosed, data.ID));
        } else {
            this.requestTabSwitchGlobal(data.ID);
            if (!this.isTabExisting(data.ID)) {
                this._onBookingClosed(data.ID);
                this.openViewer(data);
            }
        }
    }

    private _onBookingClosed(name: string) {
        //debugger; <- oida wieso is do a debuger
        for (let i = 0; i < this.openedBookings.length; i++) {
            if (name == this.openedBookings[i].entityID) {
                this.openedBookings.splice(i, 1);
                break;
            }
        }
    }

    private onHideTime: Date = null;

    public _onActivated() {
        //damit wir nicht staendig neu laden sondern nur wenn der user von der history lang genug weg war
        const RELOAD_DELAY_MS = 8_000;
        if (this.onHideTime == null) {
            return;
        }
        const timeSinceHide = new Date().getTime() - this.onHideTime.getTime();
        if (timeSinceHide >= RELOAD_DELAY_MS) {
            this.onHideTime = null;
            this.reload();
        }
    }

    public _onHide() {
        this.onHideTime = new Date();
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.internalName = "eventfinderLM";

        this.setupFinder(
            "EventFinder/GetFinderConfigurationLM",
            "EventFinder/GetEventListLM",
            lang.hitch(this, this.tableRowButton_click),
            lang.hitch(this, this.bookingFormatter)
        );

        this.openedBookings = [];
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EventFinderLM);
